import React, { PropsWithChildren, useState } from "react";
import { H2 } from "./Text";
import { motion } from "framer-motion";
import { Center } from "../css";
import { SidebarItem } from "@/types/user.types";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { dashboardSelector } from "@/store/features/dashboardSlice";
import { ChevronDown } from "lucide-react";
// import { SETTINGS_NAVBAR_LINKS } from "@/utils/constant/global.constant";

interface SideBarContentHeaderProps extends PropsWithChildren {
  heading?: string;
  className?: string;
}

interface SideBarItemProps extends PropsWithChildren {
  contendSidebars: SidebarItem[] | undefined;
  className?: string;
  isExpanded: boolean;
  isMobile?: any;
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5,
    },
  },
};

const dotVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: { opacity: 1, y: 0 },
};

const Dot: React.FC = () => <motion.div variants={dotVariants} initial="hidden" animate="visible" className="h-0.5 w-0.5 rounded-full bg-white "></motion.div>;

export const SideBarContentHeader: React.FC<SideBarContentHeaderProps> = ({ heading, children, className = "" }) => {
  return (
    <Center className={`py-19 border-b-[1px] border-stroke-light md:bg-white justify-between sticky top-0 z-30 ${className}`}>
      {heading && <H2 text={heading} />}
      {children && children}
    </Center>
  );
};

export const SideBarItemContent: React.FC<SideBarItemProps> = ({ children, className = "", contendSidebars, isExpanded,isMobile }) => {
  const { routeSegments } = useSelector(dashboardSelector);
  const [isDropdownOpen, setIsDropDownOpen] = useState(false);
  return (
    <>
      <div className={`flex items-center justify-between gap-1 ${className}`}>
        <div className="flex items-center gap-2">{children}</div>
        {contendSidebars &&
          (isExpanded ? (
            <ChevronDown
              className={`text-white h-5 w-5 md:h-4 md:w-4 ${isDropdownOpen ? " rotate-180" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setIsDropDownOpen((pre) => !pre);
              }}
            />
          ) : (
            <motion.div
              className=" flex flex-col items-center justify-center h-full pt-0.5 gap-0.5"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <Dot />
              <Dot />
              <Dot />
            </motion.div>
          ))}
      </div>

      {contendSidebars && isExpanded && isDropdownOpen && (
        <ul className="mt-4">
          {contendSidebars.map((item) => {
            const isActive = item.key === `/${routeSegments?.join("/")}`;
            return (
              <Link to={item.key} key={item.key} onClick={(e) =>{
                if (isMobile) {
                  isMobile();
                }
                e.stopPropagation();
              }}>
                <li
                  key={item.key}
                  className={`px-3 py-2.5 text-13 text-white text-start rounded-md ${
                    isActive ? "font-bold bg-primaryOpacity-10/50" : ""
                  } hover:text-white/80 hover:bg-primaryOpacity-10`}
                >
                  {item.name}
                </li>
              </Link>
            );
          })}
          {/* {SETTINGS_NAVBAR_LINKS.map((link) => {
            const isActive = routeSegments.length > 2 || link.path === `/${routeSegments[0]}/${routeSegments[1]}`;
            return (
              <Link to={link.path} key={link.path}>
                <li
                  key={link.path}
                  className={`px-3 py-2.5 text-13 text-white text-start ${isActive ? "font-bold " : ""} hover:text-white/80 hover:bg-primaryOpacity-10`}
                >
                  {link.name}
                </li>
              </Link>
            );
          })} */}
        </ul>
      )}
    </>
  );
};
